import { useState } from 'react';
import { lenses } from '@/mocks/gossip';
import SectionHead from './SectionHead';

export default function LensBoard() {
  const [active, setActive] = useState(0);
  const lens = lenses[active];

  const go = (dir: number) => {
    setActive((p) => (p + dir + lenses.length) % lenses.length);
  };

  return (
    <section id="topics" className="scroll-mt-28 py-12 md:py-16 bg-background-50">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <SectionHead
          kicker="FIVE LENSES"
          kickerZh="五大吃瓜角度"
          title="同一个热点，五种打开方式"
          desc="关联事件串来龙去脉，同类型瓜照见套路，历史对比看懂轮回，人物关系理清恩仇，幕后关联还原利益。任选一个角度，都能把热点看得更透。"
          action={
            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={() => go(-1)}
                aria-label="上一个栏目"
                className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-arrow-left-line text-lg"></i>
              </button>
              <button
                type="button"
                onClick={() => go(1)}
                aria-label="下一个栏目"
                className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </div>
          }
        />

        {/* lens tabs */}
        <div className="custom-scroll mb-6 flex gap-2 overflow-x-auto pb-1">
          {lenses.map((l, i) => (
            <button
              key={l.key}
              type="button"
              onClick={() => setActive(i)}
              className={`shrink-0 rounded-full border px-4 md:px-5 py-2 text-sm whitespace-nowrap transition-colors ${
                i === active
                  ? 'border-primary-500 bg-primary-500 text-background-50 font-semibold'
                  : 'border-background-200 bg-background-100/60 text-foreground-700 hover:border-primary-300'
              }`}
            >
              {l.label}
            </button>
          ))}
        </div>

        {/* panel */}
        <div key={lens.key} className="grid gap-5 lg:grid-cols-12 animate-fade-rise">
          <div className="relative lg:col-span-5 overflow-hidden rounded-xl border border-background-200">
            <img
              src={lens.img}
              alt={`${lens.label}栏目配图`}
              className="h-64 w-full object-cover object-top md:h-[360px]"
            />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-5">
              <p className="text-[11px] tracking-[0.25em] text-accent-300">{lens.kicker}</p>
              <h3 className="mt-1 font-heading text-2xl font-bold text-background-50">{lens.label}</h3>
            </div>
          </div>

          <div className="lg:col-span-7 flex flex-col gap-3">
            <p className="rounded-lg border border-accent-200/70 bg-accent-100/50 px-4 py-3 text-sm leading-7 text-accent-900">
              <i className="ri-lightbulb-flash-line mr-1.5 text-accent-600"></i>
              {lens.intro}
            </p>
            {lens.events.map((e) => (
              <a
                key={e.title}
                href="#deep"
                className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-100/50 px-4 py-3.5 transition-colors hover:border-primary-300 hover:bg-background-100"
              >
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm md:text-[15px] font-medium text-foreground-900 group-hover:text-primary-700">
                    {e.title}
                  </p>
                  <p className="mt-1 text-xs text-foreground-500">{e.meta}</p>
                </div>
                <span
                  className={`shrink-0 inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-bold whitespace-nowrap ${
                    e.hot === '爆'
                      ? 'bg-primary-100 text-primary-700'
                      : e.hot === '热'
                        ? 'bg-accent-100 text-accent-700'
                        : 'bg-secondary-100 text-secondary-700'
                  }`}
                >
                  <i className="ri-fire-line mr-0.5"></i>
                  {e.hot}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}